import React, { useContext } from "react";
import { ModalContext } from "../../../contexts/modalContext";
import { ModalWrapper, ViewSchoolWrapper } from "../Modals.styles";
import {
  ActionButtonOrange,
  ActionButtonOrangeSecondary,
} from "../../Buttons/ActionButton";
import { useState } from "react";
import {
  GetGroupList,
  GetSearchGroupsList,
} from "../../../api";
import { jumpToPage } from "../../../utils/constants";
import { LogInContext } from "../../../contexts/logInContext";
import { useEffect } from "react";
import { Pagination } from "../../Buttons/PaginationButtons";
import { TableContainer, Toolbar } from "@mui/material";
import { TableWrapper } from "../../Tables/Table.styles";
import ClipSpinner from "../../Loaders/ClipSpinner";
import { OrganizationsContext } from "../../../contexts/organizationsContext";
import { SchoolsContext } from "../../../contexts/schoolsContext";
import { StyledFilterButtons } from "../../../Pages/Page.styles";
import NoDataDisplay from "../../Displays/NoDataDisplay";
import FacilitatorModal from "./FacilitatorModal";
import CustomSelect from "../../InputFields/CustomSelect";

const AssignGroupToUserModal = ({ modalRef, closeModal }) => {
  const { token } = useContext(LogInContext);
  const { schoolId } = useContext(SchoolsContext);
  const { organizationId } = useContext(OrganizationsContext);
  const { showModal, setShowModal } = useContext(ModalContext);
  const [displayUsers, setDisplayUsers] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 5;
  const offset = (currentPage - 1) * ITEMS_PER_PAGE;
  const [userPageCount, setUserPageCount] = useState(1);
  let [selectedOption, setSelectedOption] = useState(null);
  const [total, setTotal] = useState(0);
  let [grpId, setGrpId] = useState("");
  let [groupId, setGroupId] = useState("");
  let [groupList, setGroupList] = useState([]);
  let [userList, setUserList] = useState([]);
  let [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const canNextPage = (displayItemsLength, itemsLength, currentPage) => {
    return (
      displayItemsLength !== ITEMS_PER_PAGE ||
      itemsLength / ITEMS_PER_PAGE === currentPage
    );
  };

  const columns = [
    {
      Header: "Name",
    },
    {
      Header: "Facilitator",
    },
    {
      Header: "",
    },
  ];

  async function fetchGroups() {
    const responseData = await GetGroupList(
      token,
      ITEMS_PER_PAGE,
      offset,
      schoolId,
      grpId,
      organizationId
    );

    if (responseData.status === "success") {
      setUsersData(responseData?.data?.data?.groups);
      setLoading(false);

      if (
        responseData.data.data.totalRecords ||
        responseData.data.data.totalRecords === 0
      ) {
        setTotal(responseData.data.data.totalRecords);
        setUserPageCount(
          Math.ceil(responseData.data.data.totalRecords / ITEMS_PER_PAGE)
        );
      }
      if (responseData.data.data.groups.length === 0) {
        setCurrentPage(1);
      }
      setDisplayUsers(responseData?.data?.data?.groups);
    } else {
      setLoading(false);
      setUsersData([]);
    }
  }

  async function fetchSearchGroups() {
    const responseData = await GetSearchGroupsList(
      schoolId,
      organizationId,
      token
    );

    if (responseData.status === "success") {
      setGroupList(
        responseData?.data?.groups.map((item) => ({
          label: item?.name,
          value: item?.name,
          id: item?.id,
        }))
      );
    } else {
      setGroupList([]);
    }
  }

  useEffect(() => {
    fetchSearchGroups();
  }, [token]);

  useEffect(() => {
      fetchGroups();
  }, [token, setUsersData, setDisplayUsers, setUserPageCount, currentPage]);

  const handleClick = (step) => {
    setCurrentPage((prevState) => prevState + step);
  };

  const handleGroupSelect = (e) => {
    setGrpId(e?.id);
    setSelectedOption(e);
  };

  return (
    <>
      <FacilitatorModal
        open={open}
        handleClose={handleClose}
        schoolId={schoolId}
        groupId={groupId}
        setGroupId={setGroupId}
        fetchGroups={fetchGroups}
        userList={userList}
      />
      {showModal && (
        <ModalWrapper ref={modalRef} onClick={closeModal}>
          <ViewSchoolWrapper style={{ height: "auto", padding: "2em" }}>
            <h1 style={{ marginBottom: "2rem" }}>
              Assign Group To Facilitator
            </h1>
            <Toolbar className="custom-toolbar">
              <div
                className="custom-search"
                style={{ maxWidth: "none", flex: "auto" }}
              >
                <CustomSelect
                  options={groupList}
                  placeholder="Select Group"
                  onChange={handleGroupSelect}
                  className="select_group"
                  value={selectedOption}
                />
              </div>
              <div className="reset-filter">
                <StyledFilterButtons>
                  <div
                    className="metrics__button-filters"
                    style={{ width: "max-content" }}
                  >
                    <ActionButtonOrange
                      theme="primary"
                      text="Filter"
                      onClick={() => {
                        fetchGroups();
                      }}
                    />
                    <ActionButtonOrangeSecondary
                      text="Reset Filters"
                      disabled={!!selectedOption ? false : true}
                      onClick={() => {
                        grpId = "";
                        setGrpId(grpId);
                        setSelectedOption(null);
                        fetchGroups();
                      }}
                    />
                  </div>
                </StyledFilterButtons>
              </div>
            </Toolbar>
            {loading && (
              <TableContainer className="custom_table_container">
                <TableWrapper>
                  <div className="loading-table">
                    <ClipSpinner />
                  </div>
                </TableWrapper>
              </TableContainer>
            )}
            {!loading && usersData.length !== 0 && (
              <TableContainer>
                <TableWrapper>
                  <>
                    <table style={{ textAlign: "start" }}>
                      <thead>
                        <tr style={{ textAlign: "justify" }}>
                          {columns.map((item, index) => (
                            <th key={index}>{item?.Header}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {usersData.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.name}</td>
                            <td>{(Array.isArray(item?.totalUsers) && item?.totalUsers.map((i, index) => (i) + `${item?.totalUsers.length !== index + 1 ? ', ' : ' '}`))}</td>
                            <td>
                              <ActionButtonOrange
                                theme={"primary"}
                                style={{
                                  width: "auto",
                                  padding: "0.1em 1.5em",
                                }}
                                text="Assign / Unassign"
                                onClick={() => {
                                  handleOpen();
                                  setGroupId(item?.id);
                                  setUserList(item?.totalUsersIds);
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {Math.ceil(total / ITEMS_PER_PAGE) > 0 && (
                      <Pagination
                        currentPage={currentPage}
                        disabledPrev={currentPage === 1}
                        disabledNext={canNextPage(
                          displayUsers.length,
                          total,
                          currentPage
                        )}
                        onClickPrev={() => handleClick(-1)}
                        onClickNext={() => handleClick(+1)}
                        onClickFirstPage={() => jumpToPage(setCurrentPage)}
                        onClickLastPage={() =>
                          jumpToPage(setCurrentPage, userPageCount)
                        }
                        total={Math.ceil(total / ITEMS_PER_PAGE)}
                      />
                    )}
                  </>
                </TableWrapper>
              </TableContainer>
            )}
            {!loading && usersData.length === 0 && (
              <NoDataDisplay
                style={{ marginTop: "1rem" }}
                message={"No groups yet"}
              />
            )}
            <div style={{ marginTop: "10px", display: "flex" }}>
              <ActionButtonOrangeSecondary
                text="Close"
                onClick={() => {
                  setShowModal(false);
                }}
              />
            </div>
          </ViewSchoolWrapper>
        </ModalWrapper>
      )}
    </>
  );
};

export default AssignGroupToUserModal;
